import FJVideoRemoveBgFormate from '../view/FJVideoRemoveBgFormate';
import { useSelector, useDispatch } from 'react-redux';
import { useCallback, useMemo } from 'react';
import { setSliceAutoExportFormate, setSliceCustomExportFormate } from '../../../../redux/slices/FJSliceVideoBgRemover';
import { FJ_EVENT_TYPE } from '../../../../constants/FJEvenTypeConstant';
import FJEvent from '../../../../store/FJEvent';

const FJVideoRemoveBgFormateContainer = () => {
    const curExportFormate = useSelector(state => state.videoBgRemover.customExportData.formate);
    const autoExportStatus = useSelector(state => state.videoBgRemover.autoExportData.formate);
    const isAutoRemoveBg = useSelector(state => state.videoBgRemover.curMenuIndex === 0);
    const dispatch = useDispatch();

    const handleChangeCurExportFormate = useCallback(
        value => {
            if (isAutoRemoveBg) {
                dispatch(setSliceAutoExportFormate(value));
            } else {
                dispatch(setSliceCustomExportFormate(value));
            }
            FJEvent.dispatch(FJ_EVENT_TYPE.HIDE_SIDE_MODAL);
        },
        [dispatch, isAutoRemoveBg],
    );

    const format = useMemo(() => {
        return isAutoRemoveBg ? autoExportStatus : curExportFormate;
    }, [isAutoRemoveBg, autoExportStatus, curExportFormate]);

    return (
        <FJVideoRemoveBgFormate
            curExportFormate={format}
            isAutoRemoveBg={isAutoRemoveBg}
            onChange={handleChangeCurExportFormate}
        />
    );
};

export default FJVideoRemoveBgFormateContainer;
